var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgWindowsOsLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m10 16.255 17.981-2.448.008 17.344-17.972.102zM27.973 33.15l.014 17.36-17.973-2.47V33.032zm2.18-19.663 23.842-3.48V30.93l-23.842.19zM54 33.313l-.005 20.83-23.842-3.365-.034-17.504z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindowsOsLogo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };